import React, { useContext, useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { Navigate, useLocation } from "react-router-dom";
import AIAssistantSidebar from "../components/AIAssistant/AIAssistantSidebar";
import Content from "../components/Content";
import Notification from "../components/Notification";
import { ProductContext } from "../store";
import Cookies from 'js-cookie';
import { isPlatformOverviewPath } from "../utils/adminRoutes";

const AIAssistant = () => {
	const [isLogged, setIsLogged] = useState(true),
		mainContent = React.useRef(null),
		location = useLocation(),
		isPlatformOverview = isPlatformOverviewPath(location.pathname),
		{ adminBootstrap, loadVisualEditor } = useContext(ProductContext);

	useEffect(() => {
		document.documentElement.scrollTop = 0
		document.scrollingElement.scrollTop = 0
		if (mainContent.current) {
			mainContent.current.scrollTop = 0
		}
	}, [location]);

	useEffect(() => {
		const Token = Cookies.get("_cb_admin_token");
		if (!Token) {
			setIsLogged(false);
		} else {
			adminBootstrap()
		}
	}, [])

	if (!isLogged) {
		return <Navigate to="/auth/login" replace />
	}

	// Admin portal: selecting a store determines available AI data.
	// Avoid redirecting to /user/dashboard (not mounted in this app).

	return (
		<>
			<section className={`applicationWrapper ${isPlatformOverview ? "platformOverviewPage" : ""}`} ref={mainContent}>
				<div className="applicationContentWrap">
					<Sidebar />
					{!loadVisualEditor &&
						<AIAssistantSidebar />
					}
					<Content type="aiassistant" />
				</div>
				<Notification />
			</section>
		</>
	);
};

export default AIAssistant;
